import { RawHtml, isSvg } from "../../../lib/ReactUtils";
import React, { useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import USER_ACTIONS from "../../UserActions";
import XButton from "./XButton";
import { createUseStyles } from "react-jss";
import { faComment } from "@fortawesome/free-solid-svg-icons";
import { isMobile } from "../../../lib/utils";
import { mergeDeepRight } from "ramda";
import widgetIconStyles from "./WidgetIconStyles.js";

const useStyles = createUseStyles((theme) =>
  mergeDeepRight(widgetIconStyles(theme), {
    container: {
      right: "19px",
      position: "fixed",
      bottom: "20px",
      height: "60px",
      zIndex: "100",
      animationName: "$slide-right",
      "@media only screen and (max-width: 600px), only screen and (max-height: 450px)":
        {
          bottom: "10px",
        },
    },
    close: {
      backgroundColor: "white",
      justifyContent: "center",
      position: "absolute",
      top: "-27px",
      right: "-5px",
      height: "27px",
      width: "27px",
      borderRadius: "50%",
      border: "solid #ededed 1px",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1) !important",
      "&:hover": { backgroundColor: "rgb(232, 232, 232) !important" },
    },
    closeContainer: {
      "&:hover": { backgroundColor: "rgb(232, 232, 232) !important" },
    },
    widgetIcon: {
      width: "100%",
      position: "static",
      borderRadius: "31px",
      background: "white !important",
      animationName: "$slide-right",
    },
    icon: {
      composes: "$widgetIconBase",
      height: "42px",
      width: "42px",
      borderRadius: "50%",
      position: "static",
      fontSize: "14px",
    },
    innerInterface: {
      display: "flex",
      alignItems: "center",
      margin: "0 9px 0 9px",
    },
    avatarContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    hyroAvatarContainer: {
      composes: "$avatarContainer",
      "@media only screen and (max-width: 600px), only screen and (max-height: 450px)":
        {
          display: "none",
        },
      margin: "auto",
      marginLeft: "8px",
    },
    customAvatarContainer: {
      composes: "$avatarContainer",
      background: theme.chatWidget,
      height: "42px",
      width: "42px",
      borderRadius: "50%",
    },
    textContainer: {
      margin: "0 10px",
      height: "42px",
      textAlign: "left",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    title: {
      fontSize: "14px",
      color: "black",
      marginBottom: "5px",
    },
    titleWithoutText: {
      composes: "$title",
      fontSize: "16px",
      marginBottom: "0",
    },
    text: {
      fontSize: "12px",
      color: theme.cardTextColorSecondary,
    },
    "@keyframes slide-right": {
      "0%": { opacity: "0", transform: "translateX(400px)" },
      "100%": { opacity: "1", transform: "translateX(0) " },
    },
  })
);

export default ({
  addUserAction,
  customAvatar,
  title,
  text,
  customPosition,
  showAvatarOnly,
}) => {
  const [isClosed, setIsClosed] = useState(false);
  const onCloseClick = () => {
    setIsClosed(true);
  };
  const styles = useStyles();

  const avatarDiv = (
    <div
      className={
        customAvatar ? styles.customAvatarContainer : styles.hyroAvatarContainer
      }
    >
      {customAvatar && isSvg(customAvatar) ? (
        <RawHtml className={styles.image} tag={"span"}>
          {customAvatar}
        </RawHtml>
      ) : (
        <img className={styles.image} src={customAvatar} alt="" />
      )}
    </div>
  );

  return (
    <div className={styles.container} style={customPosition}>
      {isClosed ? null : (
        <XButton
          close={styles.close}
          onCloseClick={onCloseClick}
          aria-label="Minimize virtual assistant activation button"
          title="Minimize virtual assistant activation button"
        />
      )}
      <button
        onClick={() => addUserAction(USER_ACTIONS.FAB_BUTTON)}
        className={styles.widgetIcon}
        aria-label="Click to open virtual assistant"
      >
        <div className={styles.innerInterface}>
          {isClosed ? null : (
            <>
              {!showAvatarOnly ? avatarDiv : null}
              <div className={styles.textContainer}>
                {title ? (
                  <div
                    className={text ? styles.title : styles.titleWithoutText}
                  >
                    {title}
                  </div>
                ) : null}
                {text ? (
                  <div className={styles.text}>
                    {isMobile() ? "24/7 Virtual Assistant" : text}
                  </div>
                ) : null}
              </div>
            </>
          )}
          {showAvatarOnly ? (
            avatarDiv
          ) : (
            <div className={styles.icon}>
              <FontAwesomeIcon
                className={styles.innerIcon}
                icon={faComment}
                aria-label="Click to open virtual assistant"
                title="Open virtual Assistant assistant"
              />
            </div>
          )}
        </div>
      </button>
    </div>
  );
};
